module.exports = __webpack_public_path__ + "img/bladeren_medium.6b226dfb.png";